<template>
  <div
    class="author-block"
    :class="themeColor"
  >
    <div class="row">
      <div class="col-12_md-3 author-block--avatar-wrapper">
        <epi-picture
          v-if="image"
          v-edit="'Image'"
          :use-picture="true"
          :image="image"
          :fit-dimensions="false"
          :sizes="dimensions"
          :sharpen="80"
          auto-quality="best"
          class="author-block--avatar"
        />
      </div>
      <div class="col-12_md-9">
        <h2
          class="font-rubrik-2--bold author-block--title"
          v-text="title"
        />
        <p
          class="font-text-3 author-block--content"
          v-text="content"
        />
      </div>
    </div>
    <dl
      v-if="questionsAndAnswers.length"
      class="author-block--qa"
    >
      <div
        v-for="(qa, index) in questionsAndAnswers"
        :key="index"
        class="author-block--qa_row"
      >
        <dt
          class="font-text-2--black"
          v-text="qa.question"
        />
        <dd
          class="font-text-3"
          v-text="qa.answer"
        />
      </div>
    </dl>
  </div>
</template>

<script>
export default {
  name: 'AuthorBlock',
  components: {},
  props: {
    theme: {
      type: String,
      default: 'Default'
    },
    image: {
      type: Object,
      default: () => {}
    },
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    questionsAndAnswers: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      dimensions: {
        small: {
          width: 104,
          height: 104
        },
        medium: {
          width: 168,
          height: 168
        },
        large: {
          width: 232,
          height: 232
        }
      }
    }
  },
  computed: {
    themeColor () {
      return `theme__color--${this.theme}`
    }
  }
}
</script>

<style lang="scss" scoped>
.author-block {
  padding: 1.5rem 1.5rem 4rem;
  position: relative;

  @include media-breakpoint-up(md) {
    overflow: hidden;
    padding: 4rem 3.75rem;
  }

  @include media-breakpoint-up(lg) {
    padding: 4rem 5.125rem 4rem 5.125rem;
  }

  @include media-breakpoint-up(xl) {
    padding: 4rem 6.5rem 4rem 3.5rem;
  }

  &--avatar {
    border-radius: 50%;
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 6.5rem;
    height: 6.5rem;
    transform: translateY(-50%);

    @include media-breakpoint-up(md) {
      transform: translateY(0);
      transform: translateX(-50%);
      width: 10.5rem;
      height: 10.5rem;
      margin: 0;
      top: 2rem;
      right: unset;
      left: unset;
    }

    @include media-breakpoint-up(lg) {
      width: 14.5rem;
      height: 14.5rem;
      left: 3.5rem;
    }

    @include media-breakpoint-up(xl) {
      left: unset;
    }

    &-wrapper {
      margin-bottom: 3rem;

      @include media-breakpoint-up(md) {
        margin-bottom: 0;
      }
    }
  }

  &--title {
    margin: 0 0 0.5rem;
  }

  &--content {
    margin-top: 0;
    margin-bottom: 0;
    white-space: pre-line;
  }

  &--qa {
    width: 100%;
    margin-bottom: 0;
    margin-top: 0.5rem;

    &_row {
      display: flex;
      flex-direction: column;
      margin-bottom: 1rem;
      align-items: baseline;

      &:last-child {
        margin-bottom: 0;
      }

      @include media-breakpoint-up(md) {
        flex-direction: row;
        width: 100%;
        margin: 0 -0.25rem 0.25rem;

        &:last-child {
          margin-bottom: 0;
        }
      }

      dt {
        text-align: left;
        text-transform: uppercase;
        letter-spacing: 0.025rem;

        @include media-breakpoint-up(md) {
          text-align: right;
          width: 25%;
          padding: 0 0.5rem;
        }
      }

      dd {
        margin-left: 0;

        @include media-breakpoint-up(md) {
          width: 75%;
          padding: 0 0.5rem;
        }
      }
    }
  }
}
</style>
